import apiClient from "../apiClient";

export const SiteAPI = {
  getSiteInformation: () => apiClient.get("/api/v1/get-site-information"),
};
